// src/pages/Servicios.jsx
import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import PageFooter from '../components/PageFooter';
import GeneralFeatures from '../components/GeneralFeatures/GeneralFeatures';
import ServiciosFeatures from '../components/ServiciosFeatures/ServiciosFeatures';
import ServiciosValue from '../components/ServiciosValue/ServiciosValue';
import ServiciosHero from '../components/ServiciosHero/ServiciosHero';
import Recommended from '../components/ModeloDestacado/ModeloDestacado';
import GeneralContacto from '../components/HomeContacto/HomeContacto';
import styles from './Servicios.module.scss';

const Servicios = () => {
  return (
    <>
      <Helmet>
        <title>Zoomlion Latinoamérica | Servicios</title>
        <meta
          name="description"
          content="Conoce los servicios que ofrece Zoomlion en Latinoamérica. Somos la marca líder en 19 países."
        />
      </Helmet>

      <div className={styles.page}>
        <ServiciosHero />

        <ServiciosValue />

        <GeneralFeatures />

        <ServiciosFeatures />

        <Recommended />

        <GeneralContacto />

        <div className={styles.footer}>
          <PageFooter />
        </div>
      </div>
    </>
  );
};

export default Servicios;
